var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoUser24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.998,
    height: 16,
    viewBox: "0 0 17.998 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_user24x24",
    transform: "translate(16182.786 5640.958)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26357",
    transform: "translate(-16182.786 -5640.958)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26356",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46757",
    d: "M-16247.5-5686.542a3.126,3.126,0,0,0,1.6-2.681,3.019,3.019,0,0,0-3-3.078,3.021,3.021,0,0,0-3.1,2.979v.1a3.008,3.008,0,0,0,1.6,2.681c-1.9.794-3.3,3.177-3.3,5.957,0,3.475,9.5,3.475,9.5,0C-16244.2-5683.464-16245.6-5685.748-16247.5-5686.542Z",
    transform: "translate(16257.999 5693.979)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46758",
    d: "M-16243.4-5688.242a3.062,3.062,0,0,0,1.2-4.169,3.109,3.109,0,0,0-4.2-1.191,4.244,4.244,0,0,0-1.2,1.092,3.476,3.476,0,0,1,1.7,4.666,2.323,2.323,0,0,1-1,1.191,6.345,6.345,0,0,1,2,1.986s1.6,2.779.8,4.864c2.2-.2,4.1-.993,4.1-2.581C-16240-5685.065-16241.4-5687.448-16243.4-5688.242Z",
    transform: "translate(16257.999 5693.979)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46759",
    d: "M-16253.1-5684.567a5.46,5.46,0,0,1,2-1.986,3.564,3.564,0,0,1-.5-4.964,2.723,2.723,0,0,1,1.2-.894,3.131,3.131,0,0,0-4.3-1.092,3.083,3.083,0,0,0-1.1,4.269,3.432,3.432,0,0,0,1.2,1.191c-2,.794-3.4,3.177-3.4,5.957,0,1.489,2,2.383,4.1,2.582C-16254.7-5681.887-16253.1-5684.567-16253.1-5684.567Z",
    transform: "translate(16257.999 5693.979)"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoUser24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_user24x24.c9b973f702aa5cf3b1e5ca983fdf845d.svg";